/* eslint-disable react/destructuring-assignment */
import styled from 'styled-components';
import ds from 'designsystem';
import FORM from 'common/consts/form';

const CustomTextArea = styled.textarea`
    font-size: ${ds.fs('l')};
    color: ${ds.brand('text')};
    font-family: ${ds.get('type.fontFamily.text')};
    font-weight: ${ds.get('type.fontWeight.regular')};
    z-index: 2;
    transition: all 0.3s;
    touch-action: manipulation;
    background: transparent;
    border: 0;
    position: relative;
    resize: none;
    height: ${FORM.DESKTOP_TEXT_AREA_LINE_HEIGHT}px;
    line-height: ${FORM.DESKTOP_TEXT_AREA_LINE_HEIGHT}px;
    
    overflow: hidden;
    
    &:focus {
        outline: 0;
    }
    &:focus::-webkit-input-placeholder {
        opacity: 0;
    }
    
    & + label {
       ${props => (!props.isEmpty ? 'top: -30px' : '')};
       ${props => (!props.isEmpty ? `font-size: ${ds.fs('s')}` : '')};
       ${props => (!props.isEmpty ? `font-weight: ${ds.get('type.fontWeight.light')}` : '')};
       ${props => (!props.isEmpty ? 'opacity: 0.8' : '')};
    }

    &:after {
        content: '';
        width: 100%;
        height: ${ds.get('metrics.xs')};
        top: 0;
        left: 0;
        background: red;
        position: absolute;
    }
`;

export default CustomTextArea;



// WEBPACK FOOTER //
// ./src/blocks/Form/CustomTextArea.jsx